import * as $ from 'jquery';
import {Global} from '../init-global';
import { TweenLite, TimelineLite, Sine, Power2, Power3, Bounce } from 'gsap';
const activated = [ TweenLite, TimelineLite, Sine, Power2, Power3, Bounce ];
require('jquery-debounced-and-throttled-resize/jquery.debouncedresize.js');


export class ProductGrid {

    protected $window: JQuery;
    protected $root: JQuery;
    protected items:ProductGridItem[];
    protected breakpoint:number = 980;
    protected viewportWidth:number; 


    constructor(elem: HTMLElement)
    {
        this.$window  = $(<any>window);
        this.$root    = $(elem);
        this.bindUI();
    }

    private bindUI = () => {
        let $gridItems = this.$root.children();
        this.items = [];

        $gridItems.each((i, elem) => {
            let n = new ProductGridItem(elem, this); 
            this.items.push(n);
        });

        this.refreshViewport();
        $(window).on('debouncedresize', () => this.refreshViewport());
    }

    private refreshViewport = () => {
        this.viewportWidth = Global.getViewport().width;
    }

    public get animationActive(): boolean {
        return (this.viewportWidth >= this.breakpoint);
    }
}

class ProductGridItem {

    protected $window: JQuery;
    protected classObj:ProductGrid;
    protected $root: JQuery;
    protected breakpoint:number = 980;
    protected $tile:JQuery;
    protected $tileBG:JQuery;
    protected tl:TimelineLite;
    protected backgroundColor:string;
    protected $header:JQuery;


    constructor(elem: HTMLElement, classObj:ProductGrid)
    {
        this.$window  = $(<any>window);
        this.$root    = $(elem);
        this.classObj = classObj;
        this.bindUI();
    }

    private bindUI = () => {

        this.$tile           = $('.c-product-tile', this.$root);
        this.$tileBG         = $(Global.newTag('div', 'c-product-tile__tile-bg'));
        this.$tile.append(this.$tileBG);
        this.backgroundColor = Global.rgb2hex(this.$tileBG.css('backgroundColor'));
        this.$header         = $('.c-product-tile__header', this.$root);


        this.$root.on({
            mouseenter: (e:any) => {
                if (this.doRollOverEffect()) {
                    this.setRollover()
                }
                e.preventDefault();
            }
        });
    }

    private setRollover = () => {
        if (typeof this.tl != 'undefined') {
            this.killRollover();
        }
        let swingValue = (this.$tile.hasClass('c-product-tile--primary')) ? '-25': '-45';
        this.tl = new TimelineLite({ onComplete: () => { this.reset(); }});
        this.tl.to(this.$tileBG, 0.15, { transform: 'rotateX(' + swingValue + 'deg)', ease: Power2.easeIn  })
        .to(this.$tileBG, 0.5, { transform: 'rotateX(0)', ease:Sine.easeOut })
        .to(this.$header, 0.15, { y: '-=20', ease: Power2.easeIn}, 0)
        .to(this.$header, 0.25, { y: '0', ease: Bounce.easeOut}, 0.18)
        .to(this.$tileBG, 0.12, { backgroundColor: Global.LightenDarkenColor(this.backgroundColor, 30), ease: Sine.easeOut }, 0)
        .to(this.$tileBG, 0.2, { backgroundColor: this.backgroundColor, ease: Sine.easeOut }, 0.15);
    }

    public killRollover = () => {
        if (typeof this.tl != 'undefined') {
            this.tl.clear();
            this.reset();
        }
    }

    private reset = () => {
        TweenLite.set([this.$tileBG, this.$header], { clearProps: 'all' });
    } 

    private doRollOverEffect = () => {
        return this.classObj.animationActive;
    }
}